import { render, staticRenderFns } from "./index_table_item.vue?vue&type=template&id=37107d34&scoped=true&"
import script from "./index_table_item.vue?vue&type=script&lang=js&"
export * from "./index_table_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37107d34",
  null
  
)

export default component.exports